import styled from 'styled-components/macro'
import { FullPage } from 'styles'

export const EmptyPageStyled = styled(FullPage)``
